import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import { ImagePresets } from "@pages/Article/components/ArticleThumbnail/utils/enums";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type PodcastsProps = {
  cardProps: ComponentProps<typeof Card>[];
  className?: string;
};

/**
 * Podcasts component to display podcasts cards for Singapore Budget 2025 page.
 * Figma: https://www.figma.com/design/FZiuxiCLQaNXAJmLRtAAY9/BUDGET-2025--WEB---APP---NL-?node-id=8518-387033&t=PUAyvdavKczeZd7x-4
 */
const Podcasts = ({
  className,
  cardProps,
}: PodcastsProps): React.ReactElement => {
  const variant: CardVariations = {
    image: {
      position: "left",
      width: "w-3/10",
      filters: {
        w: ImagePresets.MICRO,
        dpr: 1,
        f: "webp",
      },
    },
    content: {
      width: "w-7/10",
      extraClass: "pl-4",
    },
    title: {
      size: "text-lg",
      color: "text-gray-850",
      extraClass: cn("font-bold font-lct"),
    },
  };

  return (
    <div className={className} data-testid="booklet-component">
      <BlockTitle text="PODCASTS" rootClassName="mb-4 !text-lg lg:!text-3xl" />

      <div className="grid gap-4 lg:grid-cols-2">
        {cardProps.map((cardProp) => (
          <Card key={cardProp.id} {...cardProp} variations={variant} />
        ))}
      </div>
    </div>
  );
};

export default Podcasts;
